import { render } from "./UpdateTask.vue?vue&type=template&id=606c6864&scoped=true"
import script from "./UpdateTask.vue?vue&type=script&lang=js"
export * from "./UpdateTask.vue?vue&type=script&lang=js"

import "./UpdateTask.vue?vue&type=style&index=0&id=606c6864&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-606c6864"]])

export default __exports__